import http from '../../../../libs/http'
const api = process.env.VUE_APP_MICROSERVICE_API_SHOPS
export default (payload = {}, queryParams = {}) => http.post(`${api}/files`, payload, { params: { ...queryParams } })
